<template>
   <div v-bind:class="divModalOpenClass">
    <Loading :loading="this.loading"></Loading>
    <article v-show="!loading">
      <div class="step-bar-container">
        <ul>
          <li class="li-step active">
            <span class="stepnum num01"></span>
            <span class="steptext">条件入力</span>
          </li>
          <li class="li-step">
            <span class="stepnum num02"></span>
            <span class="steptext">見積り確認</span>
          </li>
          <li class="li-step">
            <span class="stepnum num03"></span>
            <span class="steptext">連絡先入力</span>
          </li>
          <li class="li-step">
            <span class="stepnum num04"></span>
            <span class="steptext">最終確認</span>
          </li>
        </ul>
      </div>
      <header class="header white-panel mb2p">
        <p class="shop-info">車検実施店舗</p>
        <h2 class="section-title">{{$route.params.ssInfo.ss_name}}</h2>
        <p class="fs14 mb4 mt8" ><a v-on:click="modalOpne()" class="color-green2">車検実施店舗の変更方法</a></p>
      </header>
      <section class="section white-panel mb2p">
        <h3 class="section-title">車検証情報</h3>
        <p class="color-font2">※直接入力する場合は必ずお手持ちの車検証を見ながら入力してください</p>
        <button v-on:click="openQrCode()" class="button button-scan">QRコードでかんたん入力</button>
        <dl class="dl dt32-dd68">
          <dt id="expiryGengo">車検満了日</dt>
          <dd>
            <div class="dropdown">
              <WarekiInputFromH :isDisabled="isQrData" v-model="car.expiryGengo" :isInvalid="!!form.expiryErrorMessage" ref="expiryOnFromH"></WarekiInputFromH>
              </div>
              <span class="date-y">年</span>
              <div class="dropdown">
              <vue-select :isDisabled="isQrData" name="select" v-model="form.expiryMonthSelect" :options="month" :isInvalid="!!form.expiryErrorMessage">
                <template slot-scope="props">
                  <option v-for="(option, key) in props.options"
                          :key="key"
                          :value=option.id
                          :selected="form.expiryMonthSelect === option.id"
                  >{{ option.value }}</option>
                </template>
              </vue-select>
              </div>
            <span class="date-m">月</span>
            <div class="dropdown">
              <vue-select :isDisabled="isQrData" name="select" v-model="form.expiryDaySelect" :options="day" :isInvalid="!!form.expiryErrorMessage">
                <template slot-scope="props">
                  <option v-for="(option, key) in props.options"
                          :key="key"
                          :value=option.id
                          :selected="form.expiryDaySelect === option.id"
                  >{{ option.value }}</option>
                </template>
              </vue-select>
            </div>
            <span class="date-d">日</span>
          </dd>
          <dd class="error">
            <p class="error-text">{{form.expiryErrorMessage}}</p>
          </dd>

          <dt id="firstRegistrationGengo">初度登録年月</dt>
          <dd>
            <div class="dropdown">
              <WarekiInputFromH :isDisabled="isQrData" v-model="car.firstRegistrationGengo" :isInvalid="!!form.firstRegistrationErrorMessage" ref="firstRegistration"></WarekiInputFromH>
            </div>
            <span class="date-y">年</span>

            <div class="dropdown">
              <vue-select :isDisabled="isQrData" name="select" v-model="form.firstRegistrationMonthSelect" :options="month" :isInvalid="!!form.firstRegistrationErrorMessage">
                <template slot-scope="props">
                  <option v-for="(option, key) in props.options"
                          :key="key"
                          :value="option.id"
                          :selected="form.firstRegistrationMonthSelect === option.id"
                  >{{ option.value }}</option>
                </template>
              </vue-select>
            </div>
            <span class="date-m">月</span>
          </dd>
          <dd class="error">
            <p class="error-text">{{form.firstRegistrationErrorMessage}}</p>
          </dd>

          <dt id="modelCode">自動車種別</dt>
          <dd>
            <div class="dropdown">
              <select v-bind:disabled="isQrData" name="" class="select w10_5em" v-bind:class="{ 'error': form.modelCodeErrorMessage }" v-model="car.model_code">
                <option :value="null">選択してください</option>
                <option
                  v-for="carType in carTypes"
                  :key="carType.id"
                  :value="carType.id">
                  {{ carType.name }}
                </option>
              </select>
            </div>
          </dd>
         <dd class="error">
            <p class="error-text">{{form.modelCodeErrorMessage}}</p>
          </dd>

          <dt id="manufacturer">車名(メーカー)</dt>
          <dd>
            <div class="dropdown">
              <select v-bind:disabled="isQrData" name="" class="select w10_5em" v-bind:class="{ 'error': form.manufacturerErrorMessage }" v-model="car.manufacturer_id">
                <option :value="null">選択してください</option>
                <option
                  v-for="manufacturer in manufacturers"
                  :key="manufacturer.id"
                  :value="manufacturer.id">
                  {{ manufacturer.manufacturer_name }}
                </option>
              </select>
            </div>
          </dd>
          <dd class="error">
            <p class="error-text">{{form.manufacturerErrorMessage}}</p>
          </dd>
          <dt id="weight">車両重量</dt>
          <dd>
            <input v-bind:disabled="isQrData" id="car_weight" v-on:blur="replaceNumber('weight')" v-model="car.weight" type="number" pattern="\d*" placeholder="(例)1,000" class="w9_0em pl-text-right text-right" v-bind:class="{ 'error': form.weightErrorMessage }"><span class="fs16 ml4">kg</span>
          </dd>
          <dd class="error">
            <p class="error-text">{{form.weightErrorMessage}}</p>
          </dd>
        </dl>
      </section>

      <section class="section white-panel mb2p">
        <h3 class="section-title">ダッシュボード情報</h3>
        <p class="color-font2">※計器を確認し、現在の走行距離の千より上の位をご入力ください</p>
        <dl class="dl estimate-list">
          <dt  id="mileage" class="fs16 pt8">走行距離</dt>
          <dd>
            <input type="number" pattern="\d*" v-on:blur="replaceNumber('mileage')" v-model="car.mileage" placeholder="(例)10" class="w6_5em pl-text-right text-right" v-bind:class="{ 'error': form.mileagErrorMessage }"><span class="fs14 ml4">,000km</span>
          </dd>
          <dd class="error">
            <p class="error-text">{{form.mileagErrorMessage}}</p>
          </dd>
        </dl>
      </section>

      <section class="section white-panel mb2p">
        <h3 class="section-title">オプション</h3>
        <p class="color-font2">※オイル交換のタイミングは前回交換半年後が目安です</p>
        <dl class="dl dt50-dd50">
          <dt class="fs16 pt8">エンジンオイル交換</dt>
          <dd>
            <fieldset class="radio-check">
              <input id="item-1" class="radio-inline_input" type="radio" name="radio" v-bind:value=true v-model="car.oil_exchanged"/>
              <label class="radio-inline_label" for="item-1">必要</label>
              <input id="item-2" class="radio-inline_input" type="radio" name="radio" v-bind:value=false v-model="car.oil_exchanged"/>
              <label class="radio-inline_label" for="item-2">不要</label>
            </fieldset>
          </dd>
        </dl>
      </section>
      <section class="section white-panel mb2p" v-if="coupon.name">
        <h3 class="section-title">クーポン</h3>
        <dl class="dl estimate-list">
          <dt class="fs16 pt8">{{coupon.name}}</dt>
          <dd class="pt8">
            <p>{{coupon.shortDescription}}</p>
          </dd>
        </dl>
      </section>

      <div class="section">
        <p class="text-center color-font2">※見積り金額以外にも料金が変動する場合があります</p>
        <button v-bind:disabled="processing" v-on:click='validationCheck(car, form)' class="button button-estimate">見積りをチェックする</button>
      </div>

    </article>

    <div class="modal_overlay">
      <div class="modal_container">
        <div class="modal_body radius8 pd24 mt8p mb8p">
          <h2 class="fs18 mb8">車検実施店舗の変更方法</h2>
          <p class="fs14 mb16">別の店舗で車検を希望する方は、ホーム画面の「設定」からマイSSを変更し、再度見積りをお願いいたします。（登録済みの情報は引き継がれます。）</p>
          <div class="bg-gray1 pd20">
            <p class="text-center font-weight-bold fs14 mb0">アプリホーム画面<br />↓<br />設定(マイページ)<br />↓<br />登録済みの過去にご利用頂いたSS<br />↓<br />マイSSを変更</p>
          </div>

          <button v-on:click="modalClose()" class="button fs16 w100p mt16 mb0 pd16 radius200">閉じる</button>
        </div>
        <!-- /.modal_body -->
      </div>
      <!-- /.modal_container -->
    </div>
    <!-- カーケアTOPに戻るボタン -->
    <form name="fm">
      <input id="tsid" type="hidden" name="tsid" v-bind:value="$route.params.nativeData.tsid">
      <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="$route.params.nativeData.popinfoid">
      <input id="otoken" type="hidden" name="otoken" v-bind:value="$route.params.nativeData.otoken">
    </form>
    <a id="qrdone" v-on:click="qrdone()"></a>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import carApi from '@/store/Api/car'
import carTypeApi from '@/store/Api/cartype'
import otherCouponApi from '@/store/Api/Common/otherCoupon'
import manufacturerApi from '@/store/Api/manufacturers'
import ssApi from '@/store/Api/Common/ss'
import WarekiInput from '@/components/WarekiInput.vue'
import WarekiInputFromH from '@/components/WarekiInputFromH.vue'
import moment from 'moment'
import modal from '../assets/modal'
import Loading from '@/views/Loading.vue'
import loadScript from 'vue-plugin-load-script'

export default {
  data: () => ({
    loading: true,
    isQrData: false,
    divModalOpenClass: 'content-wrapper',
    processing: false,
    form: {
      expiryMonthSelect: '00',
      expiryDaySelect: '00',
      firstRegistrationMonthSelect: '00',
      expiryErrorMessage: '',
      modelCodeErrorMessage: '',
      firstRegistrationErrorMessage: '',
      manufacturerErrorMessage: '',
      weightErrorMessage: '',
      mileagErrorMessage: ''

    },
    month: [
      { id: '00', value: '' },
      { id: '01', value: 1 },
      { id: '02', value: 2 },
      { id: '03', value: 3 },
      { id: '04', value: 4 },
      { id: '05', value: 5 },
      { id: '06', value: 6 },
      { id: '07', value: 7 },
      { id: '08', value: 8 },
      { id: '09', value: 9 },
      { id: '10', value: 10 },
      { id: '11', value: 11 },
      { id: '12', value: 12 }
    ],
    day: [
      { id: '00', value: '' },
      { id: '01', value: 1 },
      { id: '02', value: 2 },
      { id: '03', value: 3 },
      { id: '04', value: 4 },
      { id: '05', value: 5 },
      { id: '06', value: 6 },
      { id: '07', value: 7 },
      { id: '08', value: 8 },
      { id: '09', value: 9 },
      { id: '10', value: 10 },
      { id: '11', value: 11 },
      { id: '12', value: 12 },
      { id: '13', value: 13 },
      { id: '14', value: 14 },
      { id: '15', value: 15 },
      { id: '16', value: 16 },
      { id: '17', value: 17 },
      { id: '18', value: 18 },
      { id: '19', value: 19 },
      { id: '20', value: 20 },
      { id: '21', value: 21 },
      { id: '22', value: 22 },
      { id: '23', value: 23 },
      { id: '24', value: 24 },
      { id: '25', value: 25 },
      { id: '26', value: 26 },
      { id: '27', value: 27 },
      { id: '28', value: 28 },
      { id: '29', value: 29 },
      { id: '30', value: 30 },
      { id: '31', value: 31 }
    ],
    carTypes: [],
    manufacturers: [],
    profileInfo: [],
    coupon: {
      name: '',
      salevalue: null,
      shortDescription: '利用クーポン無し',
      usableStartAt: '',
      usableEndAt: '',
      description: ''
    },
    ssInfo: {}
  }),

  methods: {
    ...mapActions('CAR', [
      'setCar'
    ]),
    setCoupon (coupon) {
      this.coupon = coupon
    },
    isDate (strDate) {
      // 空文字は無視
      if (strDate === '') {
        return false
      }
      // 年/月/日の形式のみ許容する
      if (!strDate.match(/^\d{4}\-\d{1,2}\-\d{1,2}$/)) {
        return false
      }

      // 日付変換された日付が入力値と同じ事を確認
      // new Date()の引数に不正な日付が入力された場合、相当する日付に変換されてしまうため
      //
      const date = new Date(strDate)
      if (date.getFullYear() !== strDate.split('-')[0] ||
          date.getMonth() !== strDate.split('-')[1] - 1 ||
          date.getDate() !== strDate.split('-')[2]
      ) {
        return false
      }

      return true
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    replaceNumber (name) {
      if (name === 'weight') {
        this.car.weight = Number(this.car.weight)
      } else if (name === 'mileage') {
        this.car.mileage = Number(this.car.mileage)
      }
    },
    async validationCheck (car, form) {
      let isSuccses = true
      this.car.expiry_on = this.car.expiryGengo + '-' + this.form.expiryMonthSelect + '-' + this.form.expiryDaySelect
      this.car.first_registration_on = this.car.firstRegistrationGengo + '-' + this.form.firstRegistrationMonthSelect

      const nowMonth = moment().format('YYYY-MM')
      const nowDay = moment().format('YYYY-MM-DD')
      const expiryDay = moment(car.expiry_on).format('YYYY-MM-DD')
      const firstMonth = moment(car.first_registration_on).format('YYYY-MM')

      // イベントトラッキング処理
      this.nativeEVENTSet('ShakenButton', 'MOVED_MITSUMORI_KEKKA', 'TAP')

      // 車検満了日
      if (!this.isDate(car.expiry_on)) {
        form.expiryErrorMessage = '恐れ入りますが、正しい車検満了日を登録してください。'
        isSuccses = false
      } else if (moment(nowDay).isAfter(expiryDay, 'day')) {
        form.expiryErrorMessage = '恐れ入りますが、車検切れのお車は本車検サービスの対象外となっております。'
        isSuccses = false
      } else {
        form.expiryErrorMessage = ''
      }

      // 現在年月の20年前を取得(初度登録年月は常に日は1日のため、1日を設定)
      const twentyYearsAgo = moment().startOf('month').subtract({
        years: 20
      }).toDate()
      const firstRegistrationOn = this.dateParseYearMonth(this.car.first_registration_on)
      // 初度登録年月
      if (!this.isDate(car.first_registration_on + '-01')) {
        form.firstRegistrationErrorMessage = '恐れ入りますが、正しい初度登録年月を登録してください。'
        isSuccses = false
      } else if (moment(nowMonth).isBefore(firstMonth)) {
        form.firstRegistrationErrorMessage = '恐れ入りますが、正しい初度登録年月を登録してください。'
        isSuccses = false
      } else if (firstRegistrationOn <= twentyYearsAgo) {
        form.firstRegistrationErrorMessage = '恐れ入りますが、お客様のお車は本車検サービスの対象外となっております。'
        isSuccses = false
      } else {
        form.firstRegistrationErrorMessage = ''
      }

      // 自動車種別
      if (!car.model_code) {
        form.modelCodeErrorMessage = '自動車種別を選択して下さい。'
        isSuccses = false
      } else if (car.model_code === 4) {
        form.modelCodeErrorMessage = '恐れ入りますが、お客様のお車は本車検サービスの対象外となっております。'
        isSuccses = false
      } else {
        form.modelCodeErrorMessage = ''
      }

      // 車名(メーカー)
      if (!car.manufacturer_id) {
        form.manufacturerErrorMessage = '車名(メーカー)を選択して下さい。'
        isSuccses = false
      } else if (car.manufacturer_id === 9 || car.manufacturer_id === 10) {
        form.manufacturerErrorMessage = '恐れ入りますが、お客様のお車は本車検サービスの対象外となっております。'
        isSuccses = false
      } else {
        form.manufacturerErrorMessage = ''
      }

      // 車両重量
      if (!this.isInteger(car.weight)) {
        form.weightErrorMessage = '車両重量は半角整数で入力して下さい。'
        isSuccses = false
      } else if (car.weight === '') {
        form.weightErrorMessage = '車両重量は必須入力です。'
        isSuccses = false
      } else if (Number(car.weight) === 0) {
        form.weightErrorMessage = '車両重量は0以上を入力して下さい。'
        isSuccses = false
      } else if (String(car.weight).length > 8) {
        form.weightErrorMessage = '車両重量は8桁以内を入力して下さい。'
        isSuccses = false
      } else {
        form.weightErrorMessage = ''
      }

      // 走行距離
      if (!this.isInteger(car.mileage)) {
        form.mileagErrorMessage = '走行距離は半角整数で入力して下さい。'
        isSuccses = false
      } else if (!car.mileage) {
        form.mileagErrorMessage = '走行距離は必須入力です。'
        isSuccses = false
      } else if (Number(car.mileage) === 0) {
        form.mileagErrorMessage = '走行距離は0以上を入力して下さい。'
        isSuccses = false
      } else if (String(car.mileage).length > 8) {
        form.mileagErrorMessage = '走行距離は8桁以内を入力して下さい。'
        isSuccses = false
      } else if (Number(car.mileage) >= 200) {
        form.mileagErrorMessage = '恐れ入りますが、お客様のお車は本車検サービスの対象外となっております。'
        isSuccses = false
      } else {
        form.mileagErrorMessage = ''
      }

      if (isSuccses) {
        this.carApiPost(car)
      } else {
        let scrollId = ''
        if (form.expiryErrorMessage !== '') {
          scrollId = '#expiryGengo'
        } else if (form.firstRegistrationErrorMessage !== '') {
          scrollId = '#firstRegistrationGengo'
        } else if (form.modelCodeErrorMessage !== '') {
          scrollId = '#modelCode'
        } else if (form.manufacturerErrorMessage !== '') {
          scrollId = '#manufacturer'
        } else if (form.weight !== '') {
          scrollId = '#weight'
        } else if (form.mileage !== '') {
          scrollId = '#mileage'
        }
        this.$SmoothScroll(
          document.querySelector(scrollId),
          500,
          null,
          null,
          'y'
        )
      }
    },
    carApiPost (car) {
      this.processing = true

      // QR読み取りではない場合、QR読み取り情報を初期化
      if (!this.isQrData) {
        car.chassis_number = ''
        car.plate_number = ''
        car.motor_model = ''
        car.type_designation_number = ''
        car.classification_division_number = ''
        car.qr = ''
      }

      carApi.post(car).then(res => {
        car.id = res.data
        this.$router.push({ name: 'Estimate', params: { car, nativeData: this.$route.params.nativeData, tsId: this.$route.params.tsId, ssInfo: this.$route.params.ssInfo, profileInfo: this.$route.params.profileInfo } })
        this.processing = false
      }).catch(e => {
        this.processing = false
        this.openErrorModal('エラーが発生しました。')
      })
    },
    setCarType (carTypes) {
      this.carTypes = carTypes
    },
    setManufacturer (manufacturers) {
      this.manufacturers = manufacturers
    },
    modalClose () {
      window.scrollTo(0, window.modalHeight)
      this.divModalOpenClass = 'content-wrapper'
    },
    modalOpne () {
      window.modalHeight = window.pageYOffset
      window.scrollTo(0, 0)
      this.divModalOpenClass = 'content-wrapper modal_open'
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    openQrCode () {
      this.nativeEVENTSet('ShakenButton', 'MOVED_QRCAMERA', 'TAP')
      if ('Android' in window) {
        Android.setQRData('qrdata')
      } else if ('webkit' in window) {
        webkit.messageHandlers.setQRData.postMessage('qrdata')
      }
    },
    qrdone () {
      const qr = window.QR_DATA.body

      this.car.plate_number = qr.plate_number
      this.car.chassis_number = qr.chassis_number
      this.car.motor_model = qr.motor_model
      this.car.type_designation_number = qr.type_designation_number
      this.car.classification_division_number = qr.classification_division_number
      this.car.model_code = qr.model_code
      this.car.model_name = qr.model_name
      this.car.manufacturer_id = qr.manufacturer_id
      this.car.manufacturer_name = qr.manufacturer_name
      this.car.weight = qr.weight
      this.car.qr = qr.qr_data

      // 車検満了日
      this.car.expiry_on = qr.expiry_on
      this.car.expiryGengo = Number(qr.expiry_on.substr(0, 4))
      this.form.expiryMonthSelect = qr.expiry_on.substr(5, 2)
      this.form.expiryDaySelect = qr.expiry_on.substr(8, 2)

      // 初度登録年月
      this.car.first_registration_on = qr.first_registration_on
      this.car.firstRegistrationGengo = Number(qr.first_registration_on.substr(0, 4))
      this.form.firstRegistrationMonthSelect = qr.first_registration_on.substr(5, 2)

      this.setCar(this.car)
      // 車検満了日、初度登録年月の元号、年を取得してセットする。
      this.$refs.expiryOnFromH.firstGetGengo(qr.expiry_on)
      this.$refs.firstRegistration.firstGetGengo(qr.first_registration_on)

      this.isQrData = true
    }
  },
  computed: {
    ...mapGetters('CAR', [
      'car'
    ])
  },
  async mounted () {
    loadScript('https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js')
    loadScript('lib/js/main.js')

    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    let isApiError = false

    const ts_id = this.$route.params.nativeData.tsid
    const otoken = this.$route.params.nativeData.otoken
    const popinfo_id = this.$route.params.nativeData.popinfoid

    let priority_other_coupon = {
      usableStartAt: '',
      salevalue: 0
    }
    // 車検クーポン取得
    await otherCouponApi.get(this.$route.params.profileInfo.customer.b_cleID, popinfo_id, ts_id, otoken).then(res => {
      for (let i = 0; i < res.data.body.other_coupon.length; i++) {
        // その他クーポンのカテゴリーが1(車検クーポン)のみ設定する.
        if (res.data.body.other_coupon[i].category === 1) {
          const nowDay = moment().format('YYYY-MM-DD')
          const usableStartAt = moment(res.data.body.other_coupon[i].usableStartAt).format('YYYY-MM-DD')
          const usableEndAt = moment(res.data.body.other_coupon[i].usableEndAt).format('YYYY-MM-DD')

          // 有効期限内、且つ値引額が最大のクーポンを取得.
          if (res.data.body.other_coupon[i].salevalue > priority_other_coupon.salevalue &&
          moment(nowDay).isBetween(usableStartAt, usableEndAt, null, '[]')
          ) {
            priority_other_coupon = res.data.body.other_coupon[i]
            // その他クーポンの割引額は符号無しのため、マイナスを付与する.
            priority_other_coupon.salevalue = priority_other_coupon.salevalue * -1
            this.setCoupon(priority_other_coupon)
          }
        }
      }
    }).catch(e => {
      console.log('profile-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    await carTypeApi.get().then(res => {
      this.setCarType(res.data.car_type)
    }).catch(e => {
      console.log('profile-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    await manufacturerApi.get().then(res => {
      this.setManufacturer(res.data.manufacturer)
    }).catch(e => {
      console.log('profile-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    await ssApi.get(this.$route.params.profileInfo.best_myss.code).then(res => {
      this.setSsInfo(res.data.body.ss_info)
    }).catch(e => {
      console.log('profile-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // 見積もりIDを引数にセットする
    await carApi.get(ts_id).then(res => {
      if (res.data.car.length > 0) {
        // 車検満了日
        res.data.car[0].expiryGengo = Number(res.data.car[0].expiry_on.substr(0, 4))
        this.form.expiryMonthSelect = res.data.car[0].expiry_on.substr(5, 2)
        this.form.expiryDaySelect = res.data.car[0].expiry_on.substr(8, 2)

        // 初度登録年月
        res.data.car[0].firstRegistrationGengo = Number(res.data.car[0].first_registration_on.substr(0, 4))
        this.form.firstRegistrationMonthSelect = res.data.car[0].first_registration_on.substr(5, 2)
        res.data.car[0].oil_exchanged = this.car.oil_exchanged
        res.data.car[0].mileage = this.car.mileage
        res.data.car[0].popinfo_id = popinfo_id
        res.data.car[0].coupon = this.coupon
        res.data.car[0].coupon_id = this.coupon.couponCode
        res.data.car[0].coupon_fee = this.coupon.salevalue
        res.data.car[0].bestmy_ss_id = this.$route.params.profileInfo.best_myss.code
        res.data.car[0].bestmy_ss_prefecture = this.ssInfo.prefecture
        res.data.car[0].bestmy_ss_factory_type_flag = this.ssInfo.factory_type_flag
        this.setCar(this.car)
        this.setCar(res.data.car[0])
        // 車検満了日、初度登録年月の元号、年を取得してセットする。
        this.$refs.expiryOnFromH.firstGetGengo(res.data.car[0].expiry_on)
        this.$refs.firstRegistration.firstGetGengo(res.data.car[0].first_registration_on)
      } else {
        this.car.ts_id = ts_id
        this.car.oil_exchanged = this.car.oil_exchanged
        this.car.mileage = this.car.mileage
        this.car.popinfo_id = popinfo_id
        this.car.coupon = this.coupon
        this.car.coupon_id = this.coupon.couponCode
        this.car.coupon_fee = this.coupon.salevalue
        this.car.bestmy_ss_id = this.$route.params.profileInfo.best_myss.code
        this.car.bestmy_ss_prefecture = this.ssInfo.prefecture
        this.car.bestmy_ss_factory_type_flag = this.ssInfo.factory_type_flag
        this.setCar(this.car)
        // 車検証未登録ユーザーの車検満了日デフォルト設定は平成31年
        this.$refs.expiryOnFromH.firstGetGengo('2019-01-01')
        // 車検証未登録ユーザーの初度登録年月デフォルト設定は平成22年
        this.$refs.firstRegistration.firstGetGengo('2010-01-01')
      }
    }).catch(e => {
      console.log('profile-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
      this.car.ts_id = ts_id
      this.car.oil_exchanged = this.car.oil_exchanged
      this.car.mileage = this.car.mileage
      this.car.popinfo_id = popinfo_id
      this.car.coupon = this.coupon
      this.car.coupon_id = this.coupon.couponCode
      this.car.coupon_fee = this.coupon.salevalue
      this.car.bestmy_ss_id = this.$route.params.profileInfo.best_myss.code
      this.car.bestmy_ss_prefecture = this.ssInfo.prefecture
      this.car.bestmy_ss_factory_type_flag = this.ssInfo.factory_type_flag
      this.setCar(this.car)
      // 車検証未登録ユーザーの車検満了日デフォルト設定は平成31年
      this.$refs.expiryOnFromH.firstGetGengo('2019-01-01')
      // 車検証未登録ユーザーの初度登録年月デフォルト設定は平成22年
      this.$refs.firstRegistration.firstGetGengo('2010-01-01')
    })
    // [eventTrack] 車検見積り 画面表示完了
    this.nativePVset('SHAKEN_MITSUMORI')
    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    WarekiInput,
    WarekiInputFromH,
    Loading
  }
}
</script>
